export default [
  {
    path: '/',
    redirect: '/course/index'
  },
  /**
     * 密码登录
     */
  {
    path: '/login',
    name: 'Login',
    component: (resolve) => require(['@/views/login/login'], resolve)
  },
  /**
     * 验证码登录
     */
  {
    path: '/code-login',
    name: 'CodeLogin',
    component: (resolve) => require(['@/views/login/codeLogin'], resolve)
  },
  /**
     * 忘记密码
     * 重新设置密码
     */
  {
    path: '/reset-psw',
    name: 'ResetPsw',
    component: (resolve) => require(['@/views/login/resetPsw'], resolve)
  },
  /**
     * 注册
     */
  {
    path: '/register',
    name: 'Register',
    component: (resolve) => require(['@/views/login/register'], resolve)
  },
  /**
     * 我的
     */
  {
    path: '/mine',
    name: 'Mine',
    component: (resolve) => require(['@/views/mine/mine'], resolve),
    meta: {
      title: '我的',
      keepAlive: true, // /此组件需要缓存
      isBack: false // 用来判断是否是返回上一页
    }
  },
  /**
     * 学生档案
     */
  {
    path: '/mine/studentProfile',
    name: 'StudentProfile',
    component: (resolve) => require(['@/views/mine/studentProfile'], resolve),
    meta: { title: '学生档案',
      keepAlive: true, // /此组件需要缓存
      isBack: false // 用来判断是否是返回上一页
    }
  },
  /**
     * 学生信息
     */
  {
    path: '/mine/studentInfo',
    name: 'StudentInfo',
    component: (resolve) => require(['@/views/mine/studentInfo'], resolve),
    meta: { title: '学生信息' }
  },
  /**
       * 新增学生信息
       */
  {
    path: '/mine/addStudentInfo',
    name: 'AddStudentInfo',
    component: (resolve) => require(['@/views/mine/studentInfo'], resolve),
    meta: { title: '学生信息' }
  },
  /**
       * 教职工认证
       */
  {
    path: '/teacher/teacherCertification',
    name: 'TeacherCertification',
    component: (resolve) => require(['@/views/mine/teacherCertification'], resolve),
    meta: { title: '教职工认证' }
  },
  /**
     * 教职工解绑
     */
  {
    path: '/teacher/teacherUnbound',
    name: 'TeacherUnbound',
    component: (resolve) => require(['@/views/mine/teacherUnbound'], resolve),
    meta: { title: '教职工解绑' }
  },
  /**
     * 修改信息
     */
  {
    path: '/mine/studentInfoUpdate',
    name: 'StudentInfoUpdate',
    component: (resolve) => require(['@/views/mine/studentInfoUpdate'], resolve),
    meta: { title: '修改信息' }
  },
  /**
     * 海亮学生认证
     */
  {
    path: '/mine/studentCertification',
    name: 'StudentCertification',
    component: (resolve) => require(['@/views/mine/studentCertification'], resolve)
  },
  /**
     * 增加学生
     */
  {
    path: '/studentAdd',
    name: 'StudentAdd',
    component: (resolve) => require(['@/views/mine/studentAdd'], resolve),
    meta: { title: '增加学生' }
  },
  /**
     * 海亮教职工认证
     */
  {
    path: '/certification/staff',
    name: 'CertificationStaff',
    component: (resolve) => require(['@/views/certification/staff'], resolve)
  },
  /**
   * 完善非海亮学生信息
   */
  {
    path: '/editStu',
    name: 'CertificationEditStu',
    component: (resolve) => require(['@/views/certification/editStu'], resolve)
  },
  /**
     * 海亮学生认证
     */
  {
    path: '/certification/student',
    name: 'CertificationStudent',
    component: (resolve) => require(['@/views/certification/student'], resolve)
  },
  /**
     * 设置-首页
     */
  {
    path: '/setting/index',
    name: 'StettingIndex',
    component: (resolve) => require(['@/views/mine/setting/index'], resolve)
  },
  /**
     * 设置-账号与安全
     */
  {
    path: '/account/index',
    name: 'AccountIndex',
    component: (resolve) => require(['@/views/mine/setting/account'], resolve)
  },
  /**
     * 设置-修改手机号
     */
  {
    path: '/account/update/phone',
    name: 'UpdatePhone',
    component: (resolve) => require(['@/views/mine/setting/updatePhone'], resolve)
  },
  /**
     * 设置-修改密码
     */
  {
    path: '/account/update/psw',
    name: 'UpdatePsw',
    component: (resolve) => require(['@/views/mine/setting/updatePsw'], resolve)
  },
  /**
     * 设置-修改邮箱
     */
  {
    path: '/account/update/email',
    name: 'UpdateEmail',
    component: (resolve) => require(['@/views/mine/setting/updateEmail'], resolve)
  },
  /**
     * 设置-解绑认证
     */
  {
    path: '/account/unbind/certification',
    name: 'unBindCertification',
    component: (resolve) => require(['@/views/mine/setting/unBindCertification'], resolve)
  },
  /**
     * 设置-协议
     */
  {
    path: '/setting/agreements',
    name: 'agreements',
    component: (resolve) => require(['@/views/mine/setting/agreements'], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mine.js